import React from "react";
import { useLocation, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ShieldCheck, ArrowLeft, AlertTriangle } from "lucide-react";

const AdminLogin = () => {
  const { login } = useAuth();
  const location = useLocation();
  const unauthorized = location.state?.unauthorized;

  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center px-6">
      <div
        data-testid="admin-login-card"
        className="w-full max-w-md bg-white rounded-2xl border border-slate-100 p-8 shadow-sm"
      >
        <Link
          to="/"
          className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-[#0369A1]"
        >
          <ArrowLeft size={12} /> Back to site
        </Link>
        <div className="mt-6 h-12 w-12 rounded-full bg-[#F0F9FF] text-[#0369A1] flex items-center justify-center">
          <ShieldCheck size={20} />
        </div>
        <h1 className="mt-5 font-heading text-2xl text-slate-900">Admin Sign In</h1>
        <p className="mt-2 text-sm text-slate-500 leading-relaxed">
          Restricted to authorized Ask Chaplain Derrick admins.
        </p>

        {unauthorized && (
          <div
            data-testid="admin-unauthorized-alert"
            className="mt-5 flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 text-amber-900 text-sm"
          >
            <AlertTriangle size={16} className="mt-0.5 shrink-0" />
            <p>
              That Google account isn&apos;t on the admin allow-list. Please sign
              in with an authorized email.
            </p>
          </div>
        )}

        <button
          onClick={login}
          data-testid="admin-google-login"
          className="mt-7 w-full inline-flex items-center justify-center gap-3 bg-white border border-slate-200 hover:border-[#0369A1] rounded-full px-5 py-3 text-sm font-medium text-slate-800 transition-colors"
        >
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path fill="#EA4335" d="M12 11v3.2h4.45c-.2 1.05-.85 1.95-1.8 2.55v2.1h2.9c1.7-1.55 2.65-3.85 2.65-6.55 0-.65-.05-1.25-.15-1.85H12v.55z"/>
            <path fill="#4285F4" d="M12 21c2.43 0 4.45-.8 5.95-2.15l-2.9-2.1c-.8.55-1.85.85-3.05.85-2.35 0-4.35-1.55-5.05-3.7H3.95v2.15C5.45 19.05 8.5 21 12 21z"/>
            <path fill="#FBBC05" d="M6.95 13.9c-.2-.55-.3-1.15-.3-1.9s.1-1.35.3-1.9V7.95H3.95C3.35 9.15 3 10.55 3 12s.35 2.85.95 4.05l3-2.15z"/>
            <path fill="#34A853" d="M12 6.05c1.35 0 2.55.45 3.5 1.35l2.6-2.6C16.4 3.45 14.4 2.5 12 2.5 8.5 2.5 5.45 4.45 3.95 7.45l3 2.15C7.65 7.6 9.65 6.05 12 6.05z"/>
          </svg>
          Sign in with Google
        </button>

        <p className="mt-6 text-xs text-slate-400 leading-relaxed">
          By signing in you agree to administer Ask Chaplain Derrick submissions
          responsibly and with pastoral care.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
